import { NavigationClient } from '@azure/msal-browser';
import { type NavigateFunction } from 'react-router';

/**
 * This is an example for overriding the default function MSAL uses to navigate to other urls in your webpage
 */
export class CustomNavigationClient extends NavigationClient {
  private navigate: NavigateFunction;

  constructor(navigate: NavigateFunction) {
    super();
    this.navigate = navigate; // Store the navigate function
  }

  /**
   * Navigates to other pages within the same web application
   * You can use the useNavigate hook provided by react-router-dom to take advantage of client-side routing
   * @param url
   * @param options
   */
  async navigateInternal(url: string, options: { noHistory: boolean }) {
    const destination = new URL(url);
    const basePath = import.meta.env.BASE_URL.replace(/\/$/, '');
    const pathname =
      destination.pathname === basePath
        ? '/'
        : destination.pathname.startsWith(`${basePath}/`)
          ? destination.pathname.slice(basePath.length)
          : destination.pathname;
    const relativePath = `${pathname}${destination.search}${destination.hash}`;
    if (options.noHistory) {
      this.navigate(relativePath, { replace: true });
    } else {
      this.navigate(relativePath);
    }

    return false;
  }
}
